import applyForPersonal from './types/applyForPersonal'
import user from './types/user'
export const rules={
    applyForPersonal,
    user
}

export default {
    install(Vue){
        Vue.prototype.$rules=rules

    }
}

